import React, { useState } from 'react'
import Main from '../../cpn/Main'
import { Tabs } from 'antd'
import ExpenseInvoiceExpenseList from './ExpenseInvoiceExpenseList'
import { PlusOutlined, ScheduleOutlined, FileDoneOutlined } from '@ant-design/icons'
import ExpenseInvoiceListAll from './ExpenseInvoiceListAll'
import ExpenseInvoiceListSubmitted from './ExpenseInvoiceListSubmitted'
function ExpenseInvoiceList(props) {
    const [key, setKey] = useState(JSON.parse(localStorage.getItem('jtg-caiwu_expenseInvoiceList_key') ) || '0');
    return (
        <Main selectedKeys='/ExpenseInvoiceList' yh_qx={props.yh_qx}>
            <Tabs
                items={[
                    {
                        key: '0',
                        label: '新增',
                        children: <ExpenseInvoiceExpenseList 
                                        qy_id={props.qy_id} 
                                        qy_name={props.qy_name} 
                                        yh_id={props.yh_id} 
                                        yh_name={props.yh_name} 
                                        expenseList={props.expenseList}
                                    />,
                        icon: <PlusOutlined />,
                    },
                    {
                        key: '1',
                        label: '我已提交的',
                        children: <ExpenseInvoiceListSubmitted 
                                        qy_id={props.qy_id} 
                                        yh_id={props.yh_id} 
                                 />,
                        icon: <ScheduleOutlined />,
                    },
                    {
                        key: '2',
                        label: '所有费用票登记',
                        children: <ExpenseInvoiceListAll 
                                        qy_id={props.qy_id} 
                                        yh_id={props.yh_id} 
                                 />,
                        icon: <FileDoneOutlined />,
                    },
                ]}
                onChange={(key) => {
                    setKey(key);
                    localStorage.setItem('jtg-caiwu_expenseInvoiceList_key', JSON.stringify(key));
                }}
                activeKey={key}
            />
        </Main>
    )
}

export default ExpenseInvoiceList